import { render, staticRenderFns } from "./SMarks.vue?vue&type=template&id=abcef2ce&scoped=true"
import script from "./SMarks.vue?vue&type=script&lang=js"
export * from "./SMarks.vue?vue&type=script&lang=js"
import style0 from "./SMarks.vue?vue&type=style&index=0&id=abcef2ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcef2ce",
  null
  
)

export default component.exports